import * as cr from "./_cr";
import * as hf from "./_hf";
import * as ht from "./_ht";

import { useMdlz } from "./_csMdl";
import { a } from "./_csAbt";

import * as BoxC from "./_ccbBoxC";
import * as SrpC from "./_cccSrpC";

export const useSrpz = () => {
  const _sMdlz = useMdlz();
  const _show = (
    pz: SrpC.tSrp
  ) => {
    const _dw = cr.d('p') ? 50 : 40;
    _sMdlz.set({
      bShow: true,
      oClds: [
        cr.c(BoxC.N, {
          boxStlz: a(`br/1 dw/${_dw} dhx/70 fd/csc p/1 sc/lt1`),
          oClds: [
            cr.c(SrpC.N, {
              ... pz,
            })
          ]
        })
      ],
      onCls: pz.onCls,
    })
  };

  const _hide = () => {
    _sMdlz.set({
      bShow: false,
    })
  };

  return {
    show: _show,
    hide: _hide,
  };
};
